export default {
  login: "/login",
  signUp: "/sign-up",
  verifyEmain: "/sign-up/verify-email",
  resetPassword: "/reset-password",
  templates: {
    main: "/plantillas",
    create: "/plantillas/crear",
    edit: "/plantillas/:templateId/:organizationId/editor",
  },
  organizations: {
    root: "/:organizationAlias",
    main: "/comercios",
    details: "/comercios/:organizationId/detalles",
    create: "/comercios/crear",
    menu: {
      main: "/:organizationAlias/menus",
      read: "/:organizationAlias/menus/:menuId",
    },
    order: {
      main: "/:organizationAlias/orders",
      details: "/:organizationAlias/orders/:orderId",
      status: "/:organizationAlias/orders/:orderId/status",
      checkout: "/:organizationAlias/orders/:orderId/checkout",
      checkoutForm: "/:organizationAlias/orders/:orderId/checkout/:formId",
    },
    // @deprecated
    menus: {
      main: "/comercios/:organizationId/menus",
      read: "/comercios/:organizationId/menu/:menuId",
      create: "/comercios/:organizationId/menus/crear",
      edit: "/comercios/:organizationId/menus/:menuId/editor",
      configuration: "/comercios/:organizationId/menus/:menuId/configuracion",
    },
    websites: {
      main: "/comercios/:organizationId/websites",
      create: "/comercios/:organizationId/websites/crear",
      read: "/comercios/:organizationId/websites/:websiteId",
      edit: "/comercios/:organizationId/websites/:websiteId/editor",
    },
    orders: {
      main: "/comercios/:organizationId/pedidos",
      table: "/comercios/:organizationId/ordenes/:tableOwnership",
      details: "/comercios/:organizationId/pedidos/:orderId",
    },
    surveys: {
      main: "/comercios/:organizationId/surveys",
      details: "/comercios/:organizationId/surveys/:surveyId",
    },
    content: {
      main: "/comercios/:organizationId/contenido/:contentStatus",
      details: "/comercios/:organizationId/contenido/:contentStatus/:contentId",
    },
  },
};
